// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import translate from "@insite/client-framework/Translate";
import { AttributeTypeModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
// import Button, { ButtonIcon, ButtonIconPresentationProps } from "@insite/mobius/Button"; // Starter Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
// import { useEmblaCarousel } from "embla-carousel/react"; // Starter Custom Code
import React, { createRef, ReactNode, useCallback, useEffect, useState } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import { ButtonIcon, ButtonIconPresentationProps, ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import constants from "@store/constants";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import { TextBadge } from "@store/MobiusOverrides/Badge/Badge";
import ProductImageBadges, { ProductImageBadgesStyles } from "@store/Overrides/Components/ProductImageBadges";
import ProductPrice from "@store/Overrides/Components/ProductPrice";
import ProductTextBadges, { ProductTextBadgesStyles } from "@store/Overrides/Components/ProductTextBadges";
import ProductUnitOfMeasureSelect from "@store/Overrides/Components/ProductUnitOfMeasureSelect";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { productCompareEmptySlides } from "@store/Themes/common/props/productCompare";
import { tableProps } from "@store/Themes/common/props/table";
import useSyncScroller from "@toolkit/Framework/Common/Hooks/useSyncScroller";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusUpdateStyles, visuallyHiddenStyles } from "@toolkit/Themes/common/mixins";
import { connect, ResolveThunks } from "react-redux";

const borderWidth = "1px";
const cellWidths = pxToRemArray([282]);
const attributeTypeCellWidths = pxToRemArray([150, 225, 281]);

const cellStyles = (widths = cellWidths) => css`
    white-space: normal;
    border-width: ${borderWidth};
    border-style: solid;
    border-color: inherit;

    ${breakpointValues(
        widths.map(x =>
            x
                ? css`
                      min-width: ${x};
                      max-width: ${x};
                      width: ${x};
                  `
                : null,
        ),
    )}
`;

const attributeTypeCellStyles = (widths = attributeTypeCellWidths) => css`
    ${cellStyles(widths)}
    font-weight: ${x => x.theme.design.typography.weight.bold};
`;

const mapStateToProps = (state: ApplicationState) => ({
    productInfoByProductId:
        state.components.productInfoLists.productInfoListById[constants.productCompare.carouselId]
            ?.productInfoByProductId,
});

const mapDispatchToProps = {
    updateProductInfo,
};
/* Starter Custom Code - End */

interface OwnProps {
    id: string;
    extendedStyles?: CarouselStyles;
    title: string;
    hideTitle?: boolean;
    maxNumberOfColumns: number;
    slideDetails: ProductCarouselSlideDetails;
    // Starter Custom Code
    returnUrl?: string;
}

/* Starter Custom Code - Start */
type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext;
/* Starter Custom Code - End */

export interface ProductCarouselSlideDetails {
    slides: CarouselSlide[];
    products: ProductModel[];
    attributeTypes: AttributeTypeModel[];
}

export interface CarouselSlide {
    id: string;
    renderComponent: (options: CarouselSlideOptions) => ReactNode;
}

export interface CarouselSlideOptions {}

export interface CarouselStyles {
    titleText?: TypographyPresentationProps;
    skipCarouselButton?: SkipNavStyles;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselContentEmptyCellGridItem?: GridItemProps;
    carouselCellGridItem?: GridItemProps;
    carouselContentContainer?: GridContainerProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    attributeLabelsCellGridItem?: GridItemProps;
    attributeLabelsGridContainer?: GridContainerProps;
    attributeLabelGridItem?: GridItemProps;
    attributeLabelText?: TypographyPresentationProps;
    attributeValuesCellGridItem?: GridItemProps;
    attributeValuesWrapper?: InjectableCss;
    attributeValuesContainer?: InjectableCss;
    attributeValuesSlidesContainer?: InjectableCss;
    attributeValueSlide?: InjectableCss;
    attributeValueSlideInner?: InjectableCss;
    attributeValuesGridContainer?: GridContainerProps;
    attributeValueGridItem?: GridItemProps;
    attributeValueText?: TypographyPresentationProps;
    // Starter Custom Code
    unavailableData?: TypographyPresentationProps;
    tableWrapper?: InjectableCss;
    skipNavWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    dataTable?: DataTableProps;
    dataTableRow?: DataTableRowProps;
    dataTableCell?: DataTableCellProps;
    attributeTypeDataTableCell?: DataTableCellProps;
    attributesTableWrapper?: DataTableCellProps;
    accessibleDataTableHead?: DataTableHeadProps;
    stickyAttributeTypeDataTableCell?: DataTableCellProps;
    stickyDataTableCell?: DataTableCellProps;
    stickyAttributesTableWrapper?: InjectableCss;
    productsWrapper?: InjectableCss;
    productsContent?: InjectableCss;
    productsDataTableCell?: DataTableCellProps;
    productsAttributeTypeDataTableCell?: DataTableCellProps;
    productsEmptyDataTableCell?: DataTableCellProps;
    productTextBadges?: ProductTextBadgesStyles;
    productImageBadges?: ProductImageBadgesStyles;
    productsAddWrapper?: InjectableCss;
    productsAddLink?: LinkPresentationProps;
    productsAddIcon?: ButtonIconPresentationProps;
}

export const carouselStyles: CarouselStyles = {
    tableWrapper: tableProps.wrapper,
    skipNavWrapper: {
        css: css`
            position: relative;
            z-index: 3;
        `,
    },
    titleText: { variant: "h2" },
    wrapper: {
        css: css`
            position: relative;
        `,
    },
    attributesTableWrapper: {
        css: css`
            position: relative;
        `,
    },
    dataTable: {
        css: css`
            ${x => x.theme.dataTable.defaultProps?.css}
            border-width: 0;
        `,
    },
    accessibleDataTableHead: { css: visuallyHiddenStyles() },
    dataTableRow: {
        css: css`
            &:nth-child(even) {
                ${TextBadge}[data-has-background="false"] {
                    border: 1px solid ${getColor("common.borderDark")};
                }
            }
        `,
    },
    dataTableCell: { css: cellStyles() },
    attributeTypeDataTableCell: { css: attributeTypeCellStyles() },
    stickyAttributesTableWrapper: {
        css: css`
            pointer-events: none;
            position: absolute;
            top: 0;
            width: 100%;
            overflow: hidden;

            ${breakpoint(500, "down")} {
                display: none;
            }
        `,
    },
    stickyDataTableCell: {
        css: css`
            ${cellStyles()}
            visibility: hidden;
            border-color: transparent;
        `,
    },
    stickyAttributeTypeDataTableCell: {
        css: attributeTypeCellStyles(),
    },
    productsWrapper: {
        css: css`
            position: sticky;
            top: 0;
            z-index: 2;
            overflow: hidden;
            margin-bottom: -${borderWidth};
        `,
    },
    productsContent: {
        css: css`
            display: flex;
            overflow-x: hidden;
        `,
    },
    productsAttributeTypeDataTableCell: {
        css: css`
            ${attributeTypeCellStyles()}
            border-top-color: transparent;
            border-left-color: transparent;

            &::before {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                bottom: ${borderWidth};
                left: 0;
                background-color: ${getColor("common.background")};
                z-index: 1;
                border-right: inherit;

                ${breakpointValues(
                    attributeTypeCellWidths.map(x => (x ? `calc(${x} + ${borderWidth})` : null)),
                    "width",
                )}

                ${breakpoint(500, "down")} {
                    display: none;
                }
            }
        `,
    },
    productsDataTableCell: {
        css: css`
            ${cellStyles()}
            vertical-align: top;
        `,
    },
    productsEmptyDataTableCell: {
        css: cellStyles(),
    },
    productsAddWrapper: {
        css: css`
            display: flex;
            width: 100%;
            height: 100%;
        `,
    },
    productsAddLink: {
        css: css`
            ${focusUpdateStyles(true)}
            display: flex;
            width: 100%;
            height: 100%;
            padding: ${pxToRem(20)};
            transition: ${transitionHoverStyles("color")};

            &:hover {
                color: ${getColor("primary")};
            }
        `,
        typographyProps: {
            css: css`
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                align-items: center;

                &:hover {
                    text-decoration: underline;
                }
            `,
        },
    },
    productsAddIcon: {
        src: Plus,
        size: 40,
        css: css`
            ${focusUpdateStyles(true)}
            color: inherit;
        `,
    },
};

const Carousel = ({
    shellContext,
    theme,
    id,
    extendedStyles,
    title,
    hideTitle,
    maxNumberOfColumns,
    slideDetails,
    // Starter Custom Code
    returnUrl,
    productInfoByProductId,
    updateProductInfo,
}: Props) => {
    /* Starter Custom Code - Start */
    const stickyElement = useSyncScroller<HTMLDivElement>("syncScrollElement");
    const scrollerElement = useSyncScroller<HTMLDivElement>("syncScrollElement");
    const carouselId = constants.productCompare.carouselId;

    const getUnavailableAttribute = () => {
        return (
            <Typography {...styles.unavailableData}>
                <>&nbsp; - </>
            </Typography>
        );
    };
    /* Starter Custom Code - End */

    const afterCarousel = createRef<HTMLSpanElement>();
    const [styles] = useState(() => mergeToNew(carouselStyles, extendedStyles));

    // Starter Removed - Embla implementation

    const getProductAttributeValue = (product: ProductModel, attribute: AttributeTypeModel) => {
        const productAttributeValue = product.attributeTypes
            ?.filter(a => a.id === attribute.id)
            .map(a => a.attributeValues || [])
            .reduce((acc, currentValue) => [...acc, ...currentValue], []);

        if (productAttributeValue && productAttributeValue.length > 0) {
            return (
                <Typography
                    aria-describedby={`carousel-${id}_attribute-label-${attribute.id}`}
                    {...styles.attributeValueText}
                >
                    {productAttributeValue.map(o => o.valueDisplay).join(", ")}
                </Typography>
            );
        }

        return getUnavailableAttribute(); // Starter Custom Code
    };

    if (!slideDetails || slideDetails.slides.length === 0) {
        return null;
    }

    /* Starter Custom Code - Start */
    const emptySlidesArray = productCompareEmptySlides(slideDetails.slides.length);
    const showBrand = slideDetails.products.some(x => x.brand !== null);
    const showProductNumber = slideDetails.products.some(x => x.productNumber);
    const showCustomerProductNumber = slideDetails.products.some(x => x.customerProductNumber);
    const showManufacturerItem = slideDetails.products.some(x => x.manufacturerItem);
    const showUnitOfMeasure = slideDetails.products
        .find(x => x.unitOfMeasures?.length === 1)
        ?.unitOfMeasures?.some(x => x.unitOfMeasure !== "");
    const showBadge = slideDetails.products.some(x => x.badges?.length);
    const productInfos = getMatchingDataFromDictionary(slideDetails.products, productInfoByProductId);

    const getEmptySlides = (styles: DataTableCellProps | undefined) => {
        return emptySlidesArray.map(slide => <DataTableCell key={slide} {...styles}></DataTableCell>);
    };
    /* Starter Custom Code - End */

    return (
        <>
            <StyledWrapper {...styles.skipNavWrapper} /* Starter Custom Code */>
                <SkipNav
                    text={translate("Skip To All Attributes")} // Starter Custom Code
                    extendedStyles={styles.skipCarouselButton}
                    destination={afterCarousel}
                />
            </StyledWrapper>
            {hideTitle ? (
                <VisuallyHidden>
                    <Typography {...styles.titleText}>{title}</Typography>
                </VisuallyHidden>
            ) : (
                <Typography {...styles.titleText}>{title}</Typography>
            )}
            {/* Starter Custom Code - Start */}
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.productsWrapper}>
                    <StyledWrapper {...styles.productsContent} ref={stickyElement}>
                        <DataTable {...styles.dataTable} role="presentation">
                            <DataTableBody>
                                <DataTableRow {...styles.dataTableRow}>
                                    <DataTableCell
                                        {...styles.productsAttributeTypeDataTableCell}
                                        aria-hidden="true"
                                    ></DataTableCell>
                                    {slideDetails.slides.map(slide => (
                                        <DataTableCell
                                            {...styles.productsDataTableCell}
                                            key={slide.id}
                                            id={`slide_${slide.id}`}
                                            data-test-key={slide.id}
                                            data-test-selector="carousel_slide"
                                        >
                                            {slide.renderComponent({})}
                                        </DataTableCell>
                                    ))}
                                    {emptySlidesArray.map(slide => (
                                        <DataTableCell key={slide} {...styles.productsEmptyDataTableCell}>
                                            <StyledWrapper {...styles.productsAddWrapper}>
                                                <Link href={returnUrl} {...styles.productsAddLink}>
                                                    <ButtonIcon {...styles.productsAddIcon} />
                                                    {translate("Add product to compare")}
                                                </Link>
                                            </StyledWrapper>
                                        </DataTableCell>
                                    ))}
                                </DataTableRow>
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                </StyledWrapper>
                <span ref={afterCarousel} tabIndex={-1} />
                <StyledWrapper {...styles.attributesTableWrapper}>
                    <StyledWrapper {...styles.tableWrapper} ref={scrollerElement}>
                        <DataTable {...styles.dataTable}>
                            <DataTableHead {...styles.accessibleDataTableHead}>
                                <DataTableCell></DataTableCell>
                                {slideDetails.products.map(product => (
                                    <DataTableHeader key={product.id}>{product.productTitle}</DataTableHeader>
                                ))}
                                {emptySlidesArray.map(slide => (
                                    <DataTableHeader key={slide}>{translate("Add product to compare")}</DataTableHeader>
                                ))}
                            </DataTableHead>
                            <DataTableBody>
                                {showUnitOfMeasure && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("Unit of measures")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => {
                                            const updateUnitOfMeasure = (unitOfMeasure: string) => {
                                                updateProductInfo({
                                                    id: carouselId,
                                                    productId: product.id,
                                                    unitOfMeasure,
                                                });
                                            };
                                            const productInfo = productInfos.find(
                                                x => x.productId === product.id,
                                            ) as ProductInfo;
                                            const productContext = {
                                                product,
                                                productInfo,
                                                onUnitOfMeasureChanged: updateUnitOfMeasure,
                                            };
                                            const showUnit = product.unitOfMeasures?.some(x => x.unitOfMeasure !== "");
                                            return (
                                                <ProductContext.Provider
                                                    value={productContext}
                                                    key={`${product.id}-uom`}
                                                >
                                                    <DataTableCell {...styles.dataTableCell}>
                                                        {showUnit ? (
                                                            product.unitOfMeasures?.length === 1 ? (
                                                                <Typography>
                                                                    {product.unitOfMeasures[0].unitOfMeasureDisplay}
                                                                </Typography>
                                                            ) : product.unitOfMeasures?.length &&
                                                              product.unitOfMeasures?.length > 1 ? (
                                                                <ProductUnitOfMeasureSelect
                                                                    labelOverride=""
                                                                    sizeVariant={"xsmall" as any}
                                                                    id={`${product.id}-uom`}
                                                                />
                                                            ) : null
                                                        ) : (
                                                            getUnavailableAttribute()
                                                        )}
                                                    </DataTableCell>
                                                </ProductContext.Provider>
                                            );
                                        })}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                )}
                                <DataTableRow {...styles.dataTableRow}>
                                    <DataTableCell {...styles.attributeTypeDataTableCell}>
                                        <Typography>{translate("Price")}</Typography>
                                    </DataTableCell>
                                    {slideDetails.products.map(product => {
                                        const productInfo = productInfos.find(
                                            x => x.productId === product.id,
                                        ) as ProductInfo;
                                        const productContext = { product, productInfo };
                                        return (
                                            <ProductContext.Provider value={productContext} key={`${product.id}-price`}>
                                                <DataTableCell {...styles.dataTableCell}>
                                                    <ProductPrice
                                                        showLabel={false}
                                                        showUnitOfMeasure={false}
                                                        product={productContext}
                                                    />
                                                </DataTableCell>
                                            </ProductContext.Provider>
                                        );
                                    })}
                                    {getEmptySlides(styles.dataTableCell)}
                                </DataTableRow>
                                <DataTableRow {...styles.dataTableRow}>
                                    <DataTableCell {...styles.attributeTypeDataTableCell}>
                                        <Typography>{translate("Availability")}</Typography>
                                    </DataTableCell>
                                    {slideDetails.products.map(product => {
                                        const productInfo = productInfos.find(
                                            x => x.productId === product.id,
                                        ) as ProductInfo;
                                        const productContext = { product, productInfo };
                                        const showAvailability =
                                            productInfo.inventory?.inventoryAvailabilityDtos?.some(
                                                x => x.availability?.message !== null,
                                            ) && !product.isVariantParent;
                                        return (
                                            <ProductContext.Provider
                                                value={productContext}
                                                key={`${product.id}-inventory`}
                                            >
                                                <DataTableCell {...styles.dataTableCell}>
                                                    {showAvailability ? (
                                                        <ProductContextAvailability />
                                                    ) : (
                                                        getUnavailableAttribute()
                                                    )}
                                                </DataTableCell>
                                            </ProductContext.Provider>
                                        );
                                    })}
                                    {getEmptySlides(styles.dataTableCell)}
                                </DataTableRow>
                                {showProductNumber && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("Part #")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-productNumber`}
                                                {...styles.dataTableCell}
                                            >
                                                {product.productNumber || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                )}
                                {showCustomerProductNumber && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("My Part #")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-customerProductNumber`}
                                                {...styles.dataTableCell}
                                            >
                                                {product.customerProductNumber || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                )}
                                {showManufacturerItem && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("MFG #")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-manufacturerItem`}
                                                {...styles.dataTableCell}
                                            >
                                                {product.manufacturerItem || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                )}
                                {showBrand && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("Brands")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell key={`${product.id}-brand`} {...styles.dataTableCell}>
                                                {product.brand?.name || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                )}
                                {showBadge && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("Badges")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => {
                                            const textBadges =
                                                product.badges?.filter(
                                                    badge =>
                                                        badge.displayOnBadgeWidget &&
                                                        badge.badgeType === BadgeTypeValues.Text &&
                                                        badge.displayText,
                                                ) || [];

                                            const imageBadges =
                                                product.badges?.filter(
                                                    badge =>
                                                        badge.displayOnBadgeWidget &&
                                                        badge.badgeType === BadgeTypeValues.Image &&
                                                        badge.largeImageBadgePath,
                                                ) || [];
                                            return (
                                                <DataTableCell key={`${product.id}-badge`} {...styles.dataTableCell}>
                                                    {textBadges.length || imageBadges.length ? (
                                                        <>
                                                            {textBadges && (
                                                                <ProductTextBadges
                                                                    badgeList={textBadges}
                                                                    maxBadges={textBadges.length}
                                                                    extendedStyles={styles.productTextBadges}
                                                                />
                                                            )}
                                                            {imageBadges && (
                                                                <ProductImageBadges
                                                                    badgeList={imageBadges}
                                                                    maxBadges={imageBadges.length}
                                                                    extendedStyles={styles.productImageBadges}
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        getUnavailableAttribute()
                                                    )}
                                                </DataTableCell>
                                            );
                                        })}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                )}
                                {slideDetails.attributeTypes.map(attribute => (
                                    <DataTableRow key={attribute.id} {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography id={`carousel-${id}_attribute-label-${attribute.id}`}>
                                                {attribute.label || attribute.name}
                                            </Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell key={`${product.id}-attributes`} {...styles.dataTableCell}>
                                                {getProductAttributeValue(product, attribute)}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.dataTableCell)}
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                    <StyledWrapper {...styles.stickyAttributesTableWrapper} aria-hidden="true">
                        <DataTable {...styles.dataTable}>
                            <DataTableBody>
                                {showUnitOfMeasure && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                            <Typography>{translate("Unit of measures")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => {
                                            const updateUnitOfMeasure = (unitOfMeasure: string) => {
                                                updateProductInfo({
                                                    id: carouselId,
                                                    productId: product.id,
                                                    unitOfMeasure,
                                                });
                                            };
                                            const productInfo = productInfos.find(
                                                x => x.productId === product.id,
                                            ) as ProductInfo;
                                            const productContext = {
                                                product,
                                                productInfo,
                                                onUnitOfMeasureChanged: updateUnitOfMeasure,
                                            };
                                            const showUnit = product.unitOfMeasures?.some(x => x.unitOfMeasure !== "");
                                            return (
                                                <ProductContext.Provider
                                                    value={productContext}
                                                    key={`${product.id}-uom`}
                                                >
                                                    <DataTableCell {...styles.stickyDataTableCell}>
                                                        {showUnit ? (
                                                            product.unitOfMeasures?.length === 1 ? (
                                                                <Typography>
                                                                    {product.unitOfMeasures[0].unitOfMeasureDisplay}
                                                                </Typography>
                                                            ) : product.unitOfMeasures?.length &&
                                                              product.unitOfMeasures?.length > 1 ? (
                                                                <ProductUnitOfMeasureSelect
                                                                    labelOverride=""
                                                                    sizeVariant={"xsmall" as any}
                                                                    id={`${product.id}-uom`}
                                                                />
                                                            ) : null
                                                        ) : (
                                                            getUnavailableAttribute()
                                                        )}
                                                    </DataTableCell>
                                                </ProductContext.Provider>
                                            );
                                        })}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                )}
                                <DataTableRow {...styles.dataTableRow}>
                                    <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                        <Typography>{translate("Price")}</Typography>
                                    </DataTableCell>
                                    {slideDetails.products.map(product => {
                                        const productInfo = productInfos.find(
                                            x => x.productId === product.id,
                                        ) as ProductInfo;
                                        const productContext = { product, productInfo };
                                        return (
                                            <ProductContext.Provider value={productContext} key={`${product.id}-price`}>
                                                <DataTableCell {...styles.stickyDataTableCell}>
                                                    <ProductPrice
                                                        showLabel={false}
                                                        showUnitOfMeasure={false}
                                                        product={productContext}
                                                    />
                                                </DataTableCell>
                                            </ProductContext.Provider>
                                        );
                                    })}
                                    {getEmptySlides(styles.stickyDataTableCell)}
                                </DataTableRow>
                                <DataTableRow {...styles.dataTableRow}>
                                    <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                        <Typography>{translate("Availability")}</Typography>
                                    </DataTableCell>
                                    {slideDetails.products.map(product => {
                                        const productInfo = productInfos.find(
                                            x => x.productId === product.id,
                                        ) as ProductInfo;
                                        const productContext = { product, productInfo };
                                        const showAvailability =
                                            productInfo.inventory?.inventoryAvailabilityDtos?.some(
                                                x => x.availability?.message !== null,
                                            ) && !product.isVariantParent;
                                        return (
                                            <ProductContext.Provider
                                                value={productContext}
                                                key={`${product.id}-inventory`}
                                            >
                                                <DataTableCell {...styles.stickyDataTableCell}>
                                                    {showAvailability ? (
                                                        <ProductContextAvailability />
                                                    ) : (
                                                        getUnavailableAttribute()
                                                    )}
                                                </DataTableCell>
                                            </ProductContext.Provider>
                                        );
                                    })}
                                    {getEmptySlides(styles.stickyDataTableCell)}
                                </DataTableRow>
                                {showProductNumber && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                            <Typography>{translate("Part #")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-productNumber`}
                                                {...styles.stickyDataTableCell}
                                            >
                                                {product.productNumber || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                )}
                                {showCustomerProductNumber && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                            <Typography>{translate("My Part #")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-customerProductNumber`}
                                                {...styles.stickyDataTableCell}
                                            >
                                                {product.customerProductNumber || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                )}
                                {showManufacturerItem && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                            <Typography>{translate("MFG #")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-manufacturerItem`}
                                                {...styles.stickyDataTableCell}
                                            >
                                                {product.manufacturerItem || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                )}
                                {showBrand && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                            <Typography>{translate("Brands")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell key={`${product.id}-brand`} {...styles.stickyDataTableCell}>
                                                {product.brand?.name || getUnavailableAttribute()}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                )}
                                {showBadge && (
                                    <DataTableRow {...styles.dataTableRow}>
                                        <DataTableCell {...styles.attributeTypeDataTableCell}>
                                            <Typography>{translate("Badges")}</Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => {
                                            const textBadges =
                                                product.badges?.filter(
                                                    badge =>
                                                        badge.displayOnBadgeWidget &&
                                                        badge.badgeType === BadgeTypeValues.Text &&
                                                        badge.displayText,
                                                ) || [];

                                            const imageBadges =
                                                product.badges?.filter(
                                                    badge =>
                                                        badge.displayOnBadgeWidget &&
                                                        badge.badgeType === BadgeTypeValues.Image &&
                                                        badge.largeImageBadgePath,
                                                ) || [];
                                            return (
                                                <DataTableCell
                                                    key={`${product.id}-badge`}
                                                    {...styles.stickyDataTableCell}
                                                >
                                                    {textBadges.length || imageBadges.length ? (
                                                        <>
                                                            {textBadges && (
                                                                <ProductTextBadges
                                                                    badgeList={textBadges}
                                                                    maxBadges={textBadges.length}
                                                                    extendedStyles={styles.productTextBadges}
                                                                />
                                                            )}
                                                            {imageBadges && (
                                                                <ProductImageBadges
                                                                    badgeList={imageBadges}
                                                                    maxBadges={imageBadges.length}
                                                                    extendedStyles={styles.productImageBadges}
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        getUnavailableAttribute()
                                                    )}
                                                </DataTableCell>
                                            );
                                        })}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                )}
                                {slideDetails.attributeTypes.map(attribute => (
                                    <DataTableRow key={attribute.id} {...styles.dataTableRow}>
                                        <DataTableCell {...styles.stickyAttributeTypeDataTableCell}>
                                            <Typography id={`carousel-${id}_attribute-label-${attribute.id}`}>
                                                {attribute.label || attribute.name}
                                            </Typography>
                                        </DataTableCell>
                                        {slideDetails.products.map(product => (
                                            <DataTableCell
                                                key={`${product.id}-attributes`}
                                                {...styles.stickyDataTableCell}
                                            >
                                                {getProductAttributeValue(product, attribute)}
                                            </DataTableCell>
                                        ))}
                                        {getEmptySlides(styles.stickyDataTableCell)}
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            {/* Starter Custom Code - End */}
            {/* Starter Moved - span ref={afterCarousel} - up */}
        </>
    );
};

Carousel.defaultProps = {
    maxNumberOfColumns: 4,
};

export default withIsInShell(connect(mapStateToProps, mapDispatchToProps)(withTheme(Carousel))); // Starter Custom Code
